import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FaqServices from "../services/FaqServices";
import DeleteButton from "./Button/DeleteButton";
import UpdateFaq from "./Update Model/UpdateFaq";
import Modal from "react-modal";
import useAsync from '../hooks/useAsync';

function FaqList() {

  const [language, setLanguage] = useState("English"); // Default language is English
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [faqs, setFaqs] = useState([]);
  const [faqsCat, setFaqsCat] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  // const { data, error, isLoading, run } = useAsync(FaqServices.getAllFaqLanguage(language));
  
  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
};

const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
};

const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
};
const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
};
const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
};


const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
};


  
  // useEffect(() => {
  //   const fetchFaqsByLanguage = async () => {
  //     try {
  //       const response = await FaqServices.getAllFaqLanguage(language);
  //       if (response?.status) {
  //         const allFaqs = response?.data || [];
  //         setFaqs(allFaqs);
  
  //         // Extract unique categories
  //         const uniqueCategories = [
  //           ...new Set(
  //             allFaqs
  //               .filter((faq) => faq?.category)
  //               .map((faq) =>
  //                 language === "English"
  //                   ? faq.category.titleEnglish
  //                   : faq.category.titleHindi
  //               )
  //           ),
  //         ];
  //         setCategories(uniqueCategories);
  
  //         // Set the first category as active
  //         if (uniqueCategories.length > 0) {
  //           setActiveCategory(uniqueCategories[0]);
  //         } else {
  //           setActiveCategory("");
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching FAQs by language:", error);
  //     }
  //   };
  
  //   fetchFaqsByLanguage();
  // }, [language]);
    // Function to fetch FAQs by language
    const fetchFaqsByLanguage = async () => {
      try {
        const response = await FaqServices.getAllFaqLanguage(language);
        if (response?.status) {
          const allFaqs = response?.data || [];
          setFaqs(allFaqs);
  
          // Extract unique categories
          const uniqueCategories = [
            ...new Set(
              allFaqs
                .filter((faq) => faq?.category)
                .map((faq) =>
                  language === "English"
                    ? faq.category.titleEnglish
                    : faq.category.titleHindi
                )
            ),
          ];
          setCategories(uniqueCategories);
  
          // Set the first category as active
          if (uniqueCategories.length > 0) {
            setActiveCategory(uniqueCategories[0]);
          } else {
            setActiveCategory("");
          }
        }
      } catch (error) {
        console.error("Error fetching FAQs by language:", error);
      }
    };
  
    // Call fetchFaqsByLanguage when the language changes
    useEffect(() => {
      fetchFaqsByLanguage();
    }, [language]);
  useEffect(() => {
    if (activeCategory) {
      fetchFaqsByCategory(activeCategory);
    }
  }, [activeCategory, faqs]);
  
  const fetchFaqsByCategory = async (categoryTitle) => {
    try {
      const selectedCategory = faqs.find((faq) =>
        language === "English"
          ? faq.category?.titleEnglish === categoryTitle
          : faq.category?.titleHindi === categoryTitle
      );
  
      if (selectedCategory?.category?._id) {
        const response = await FaqServices.getCategoryByFaq(
          selectedCategory.category._id,
          language
        ); // Send language in body
        if (response?.status) {
          setFaqsCat(response?.data || []);
        }
      }
    } catch (error) {
      console.error("Error fetching FAQs by category:", error);
    }
  };
  

  // Handle category click
  const handleCategoryClick = (categoryTitle) => {
    setActiveCategory(categoryTitle);
    fetchFaqsByCategory(categoryTitle);
  };
  

  return (
    <div className="right_col" role="main">
      {/* Language Selector */}
      <div className="container-box user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
      <div className="language-btn d-flex px-4" style={{ gap: "20px", marginBottom: "70px" }}>
        <ul className="nav nav-pills mb-3" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${language === "English" ? "active" : ""}`}
              type="button"
              onClick={() => setLanguage("English")}
            >
              English
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${language === "Hindi" ? "active" : ""}`}
              type="button"
              onClick={() => setLanguage("Hindi")}
            >
              Hindi
            </button>
          </li>
        </ul>
        <Link className="Add-new-btn site-btn-green ms-auto" to="/add-faq">
          <img src="img/add-plus.svg" alt="" />
          <span className="ms-2">Add New</span>
        </Link>
      </div>

      {/* Category Tabs */}
      <div className="container-box-inner px-4">
        <div className="container-box-top-subheading">
          <p>Frequently Asked Questions</p>
        </div>
        <ul className="nav nav-pills mb-3" role="tablist">
          {categories.map((category, index) => (
            <li className="nav-item" role="presentation" key={index}>
              <button
                className={`nav-link ${activeCategory === category ? "active" : ""}`}
                type="button"
                onClick={() => handleCategoryClick(category)}
              >
                {category}
              </button>
            </li>
          ))}
        </ul>

        {/* FAQ Content */}
        <div className="faq-outer">
            <div className="accordion" id="accordionExample">
              {faqsCat.length > 0 ? (
                faqsCat.map((faq, index) => (
                  <div className="accordion-item-outer" key={faq._id}>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse${index}`}
                        >
                          <span className="qustn">Q :</span>{" "}
                          <span>{faq.question}</span>
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div className="faq-answer-inside">
                            <p>Answer :</p>
                            <p>{faq.answer}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="faq-edit-grp">
                    <button className="video-edit-btn" 
                                                                onClick={() => handleEditDetails(faq)}>
                        <i className="fa fa-pencil"></i>
                      </button>
                      <button className="video-delete-btn"  onClick={() => handleDelete(faq)}>
                        <i className="fa fa-trash"></i>
                        </button>
                    </div>
                  </div>
                ))
              ) : (
                <p>No FAQs available for this category.</p>
              )}
            </div>
          </div>
        
      </div>
    </div>
    <Modal
                isOpen={isEditModalOpen}
                onRequestClose={closeEditModal}
                contentLabel="User Details"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <UpdateFaq faq={selectedEdit} closeModal={closeEditModal} onSuccess={() => fetchFaqsByLanguage()}  />
            </Modal>
            <Modal
                isOpen={isDeleteModalOpen}
                onRequestClose={closeDeleteModal}
                contentLabel="Delete Confirmation"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <DeleteButton data={selectedEdit} page="Faq" closeModal={closeDeleteModal}   onSuccess={() => fetchFaqsByLanguage()}  />
            </Modal>
    </div>
  );
}

export default FaqList;


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import FaqServices from "../services/FaqServices";

// function FaqList() {
//   const [language, setLanguage] = useState("English");
//   const [categories, setCategories] = useState([]);
//   const [activeCategory, setActiveCategory] = useState("");
//   const [faqs, setFaqs] = useState([]);

//   // Fetch FAQs based on the selected language
//   useEffect(() => {
//     const fetchFaqs = async () => {
//       try {
//         const response = await FaqServices.getAllFaqLanguage(language);
//         if (response?.status) {
//           setFaqs(response?.data || []);
//           const uniqueCategories = [
//             ...new Set(
//               response?.data?.map((faq) =>
//                 language === "English"
//                   ? faq?.category?.titleEnglish
//                   : faq?.category?.titleHindi
//               )
//             ),
//           ];
//           setCategories(uniqueCategories);
//           setActiveCategory(); 
//         }
//       } catch (error) {
//         console.error("Error fetching FAQs:", error);
//       }
//     };
//     fetchFaqs();
//   }, [language]);
//   useEffect(() => {
//     const fetchFaqs = async () => {
//       try {
//         const response = await FaqServices.getAllFaqCategory(cat._id, body);
//         if (response?.status) {
//           setFaqs(response?.data || []);
//           const uniqueCategories = [
//             ...new Set(
//               response?.data?.map((faq) =>
//                 language === "English"
//                   ? faq?.category?.titleEnglish
//                   : faq?.category?.titleHindi
//               )
//             ),
//           ];
//           setCategories(uniqueCategories);
//           setActiveCategory(); 
//         }
//       } catch (error) {
//         console.error("Error fetching FAQs:", error);
//       }
//     };
//     fetchFaqs();
//   }, [language]);
//   // Filter FAQs based on active category
//   const filteredFaqs =
//     activeCategory === 
//       ? faqs
//       : faqs.filter((faq) =>
//           language === "English"
//             ? faq?.category?.titleEnglish === activeCategory
//             : faq?.category?.titleHindi === activeCategory
//         );

//   return (
//     <div className="right_col" role="main">
//       <div className="language-btn d-flex px-4" style={{ gap: "20px", marginBottom: "70px" }}>
//         <ul className="nav nav-pills mb-3" role="tablist">
//           <li className="nav-item" role="presentation">
//             <button
//               className={`nav-link ${language === "English" ? "active" : ""}`}
//               type="button"
//               onClick={() => setLanguage("English")}
//             >
//               English
//             </button>
//           </li>
//           <li className="nav-item" role="presentation">
//             <button
//               className={`nav-link ${language === "Hindi" ? "active" : ""}`}
//               type="button"
//               onClick={() => setLanguage("Hindi")}
//             >
//               Hindi
//             </button>
//           </li>
//         </ul>
//         <Link className="Add-new-btn site-btn-green ms-auto" to="/add-faq">
//           <img src="img/add-plus.svg" alt="" />
//           <span className="ms-2">Add New</span>
//         </Link>
//       </div>

//       <div className="container-box-inner">
//         <div className="container-box-top-subheading">
//           <p>Frequently Asked Questions</p>
//         </div>

//         {/* Render category tabs */}
//         <ul className="nav nav-pills mb-3" role="tablist">
    
//           {categories.map((category, index) => (
//             <li className="nav-item" role="presentation" key={index}>
//               <button
//                 className={`nav-link ${activeCategory === category ? "active" : ""}`}
//                 type="button"
//                 onClick={() => setActiveCategory(category)}
//               >
//                 {category}
//               </button>
//             </li>
//           ))}
//         </ul>

//         {/* Render FAQs */}
//         <div className="faq-content">
//           {filteredFaqs.length > 0 ? (
//             filteredFaqs.map((faq) => (
//               <div key={faq._id} className="faq-item">
//                 <h5>Question: {faq.question}</h5>
//                 <p>Answer: {faq.answer}</p>
//                 <p>
//                   Category:{" "}
//                   {language === "English"
//                     ? faq.category?.titleEnglish
//                     : faq.category?.titleHindi}
//                 </p>
//               </div>
//             ))
//           ) : (
//             <p>No FAQs available for this category.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default FaqList;
